import React from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel, TabIndicator } from '@chakra-ui/react';
import SecuritySettings from './SecuritySettings';
import KidsSettings from './KidsSettings';
import ParentSettings from './ParentSettings';

function SettingsContent() {
    return (
        <div className='my-3'>
            <Tabs position='relative' className='my-6' variant='unstyled'>
                <TabList className='border-b-2 border-[#F4F5F7]'>
                    <Tab className='rounded-t-lg'><div className='mx-4 font-medium'>Parent Profile</div></Tab>
                    <Tab className='rounded-t-lg'><div className='mx-4 font-medium'>Child Profile</div></Tab>
                    <Tab className='rounded-t-lg'><div className='mx-4 font-medium'>Security</div></Tab>
                </TabList>
                <TabIndicator mt='-4px' height='4px' bg='#90BCB5' borderRadius='10px 10px 0px 0px'/>
                <TabPanels>
                    <TabPanel>
                        <ParentSettings />
                    </TabPanel>
                    <TabPanel>
                        <KidsSettings />
                    </TabPanel>
                    <TabPanel>
                        <SecuritySettings />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </div>
    );
}

export default SettingsContent;
